import { LitElement, html, css } from "lit-element";

// language=CSS
export const InputSimpleStyle = css`
	.input-simple {
		position: relative;
		display: block;
	}

	.input-simple > input {
		display: block;
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		border: none;
		width: 100%;
		height: 40px;
		padding:  var(--sw-input-simple-padding, 0 20px); 
		outline: none;
		background-color: var(--app-white);
		border-radius: 3px;
		box-sizing: border-box;
	}

	.input-simple[round] > input {
		border-radius: 30px;
	}

	.input-simple[fat] > input {
		padding: 25px 30px;
	}

	.input-simple > input:invalid {
		box-shadow: none;
	}

	.input-simple > input-md-decorator {
		position: relative;
		display: block;
		margin: auto;
		height: 1px;
		width: 100%;
		color: var(--app-primary);
	}

	/* input label */
	.input-simple > input-md-decorator > label {
		text-align: left;
		font-size: 16px;
		line-height: 20px;
		padding-left: 20px;
		display: block;
		pointer-events: none;
		opacity: 1;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		transform-origin: 0 0;
		transition-property: opacity, transform;
		transition-duration: 0.15s;
		transition-timing-function: ease-out;
		will-change: transform;
		transform: translate3d(0px, -2em, 0px);
	}

	.input-simple > input:focus + input-md-decorator > input-underline {
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}
`;

// language=CSS
export const InputSimpleHostStyle = css`
	:host {
		position: relative;
	}

	:host > input {
		display: block;
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		border: none;
		width: 100%;
		height: 40px;
		padding:  var(--sw-input-simple-padding, 0 20px);
		outline: none;
		background-color: var(--app-white);
		border-radius: var(--input-simple-border-radius, 3px);
		box-sizing: border-box;
	}

	:host[round] > input {
		border-radius: 30px;
	}

	:host[fat] > input {
		padding: 25px 30px;
	}

	:host > input:invalid {
		box-shadow: none;
	}

	:host > input-md-decorator {
		position: relative;
		display: block;
		margin: auto;
		height: 1px;
		width: 100%;
		color: var(--app-primary);
	}

	/* input label */
	:host > input-md-decorator > label {
		text-align: left;
		font-size: 16px;
		line-height: 20px;
		padding-left: 20px;
		display: block;
		pointer-events: none;
		opacity: 1;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		transform-origin: 0 0;
		transition-property: opacity, transform;
		transition-duration: 0.15s;
		transition-timing-function: ease-out;
		will-change: transform;
		transform: translate3d(0px, -2em, 0px);
	}

	:host > input:focus + input-md-decorator > input-underline {
		transform: scale3d(1, 1, 1);
		transition: transform 0.2s ease-out;
	}
`;
export class InputSimple extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			value: { type: String },
			label: { type: String },
			type: { type: String },
			required: { type: Boolean },
			disabled: { type: Boolean },
			hidden: { type: Boolean }
		};
	}

	static get styles() {
		return InputSimpleHostStyle;
	}

	render() {
		return html`
			<input
				type="${this.type}"
				value="${this.value ? this.value : ""}"
				name="${this.name}"
				placeholder="${this.label ? this.label : ""}"
				?hidden="${this.hidden}"
				?required="${this.required}"
				?disabled="${this.disabled}"
			/>
		`;
	}
}

customElements.define("input-simple", InputSimple);
